/* GP Bikes collection skin — interactivity (loaded only with gp_skin).
   - Sidebar accordions, "View more", bottom-description Read More
   - Filter / Sort: GP links → AJAX section swap (Section Rendering API). Active
     states come back server-rendered. No reload; works in editor + preview.
   - Results-Per-Page (12/24/108) + Prev/Next/Go-To-Page: CLIENT-SIDE over the
     server-loaded set (Shopify can't read a custom ?per_page param). The grid is
     paginated server-side by 108; we slice it by the chosen per-page and lazily
     fetch further server pages for collections larger than 108. */
(function () {
  var SECTION_SEL = '.facest-filters-section.gp-skin';
  var PER_OPTS = [12, 24, 108];
  var state = { perPage: 24, page: 1, total: 0, loaded: 0, serverPage: 1, serverPages: 1, loading: false };

  function $section() { return document.querySelector(SECTION_SEL); }
  function $grid() { var s = $section(); return s && s.querySelector('[data-product-container]'); }
  function $items() {
    var g = $grid();
    if (!g) return [];
    return Array.prototype.slice.call(g.children).filter(function (n) {
      return n.classList && n.classList.contains('m-product-item');
    });
  }
  function scrollToTop() {
    var s = $section(); if (!s) return;
    var y = s.getBoundingClientRect().top + window.scrollY - 90;
    window.scrollTo({ top: y > 0 ? y : 0, behavior: 'smooth' });
  }

  /* ---------- sidebar UI ---------- */
  function initUI(root) {
    root = root || document;
    root.querySelectorAll('[data-gp-acc-toggle]').forEach(function (btn) {
      if (btn.dataset.gpBound) return; btn.dataset.gpBound = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-gp-acc]'); if (!item) return;
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    root.querySelectorAll('[data-gp-viewmore-toggle]').forEach(function (btn) {
      if (btn.dataset.gpBound) return; btn.dataset.gpBound = '1';
      btn.addEventListener('click', function () {
        var list = btn.closest('[data-gp-viewmore]'); if (!list) return;
        var ex = list.classList.toggle('is-expanded');
        btn.textContent = ex ? (btn.dataset.less || 'View less') : (btn.dataset.more || 'View more');
      });
    });
    root.querySelectorAll('[data-gp-desc]').forEach(function (block) {
      if (block.dataset.gpBound) return; block.dataset.gpBound = '1';
      var body = block.querySelector('.gp-coll-desc__body');
      var toggle = block.querySelector('[data-gp-desc-toggle]');
      if (!body || !toggle) return;
      /* Clean the merchant SEO block: remove its embedded green Read-More widget
         and whitespace-only spacer paragraphs (the ugly gaps) for a tidy GP look. */
      body.querySelectorAll('#toggleButton, .read-more-button, .description-content button').forEach(function (b) { b.remove(); });
      body.querySelectorAll('p').forEach(function (p) {
        var t = (p.textContent || '').replace(/ /g, ' ').trim();
        if (t === '' && !p.querySelector('img,iframe,svg,a,picture')) p.remove();
      });
      if (body.scrollHeight <= body.clientHeight + 4) { block.classList.add('is-short'); toggle.style.display = 'none'; return; }
      var label = toggle.querySelector('.gp-coll-desc__toggle-label');
      toggle.addEventListener('click', function () {
        var ex = block.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', ex ? 'true' : 'false');
        if (label) label.textContent = ex ? 'less…' : 'more…';
      });
    });
  }

  function applyMobileDefault() {
    var mobile = window.matchMedia('(max-width: 899px)').matches;
    document.querySelectorAll('.gp-side__block[data-gp-acc]').forEach(function (b) {
      var btn = b.querySelector('[data-gp-acc-toggle]');
      if (mobile) b.classList.remove('is-open'); else b.classList.add('is-open');
      if (btn) btn.setAttribute('aria-expanded', mobile ? 'false' : 'true');
    });
  }

  function reinitImages(root) {
    root.querySelectorAll('responsive-image').forEach(function (el) {
      try { if (el.disconnectedCallback) el.disconnectedCallback(); if (el.connectedCallback) el.connectedCallback(); } catch (e) {}
    });
  }
  function reinitProducts() {
    try {
      if (window.MinimogTheme) {
        if (MinimogTheme.Wishlist && MinimogTheme.Wishlist.setWishlistButtonsState) MinimogTheme.Wishlist.setWishlistButtonsState();
        if (MinimogTheme.CompareProduct && MinimogTheme.CompareProduct.setCompareButtonsState) MinimogTheme.CompareProduct.setCompareButtonsState();
      }
    } catch (e) {}
  }

  /* ---------- client-side per-page + pagination ---------- */
  function readState(keepPerPage) {
    var g = $grid(); if (!g) return;
    if (!keepPerPage) {
      var saved = parseInt(localStorage.getItem('gpPerPage') || '24', 10);
      state.perPage = PER_OPTS.indexOf(saved) > -1 ? saved : 24;
    }
    state.loaded = $items().length;
    state.total = parseInt(g.getAttribute('data-gp-total') || '0', 10) || state.loaded;
    state.serverPages = parseInt(g.getAttribute('data-total-pages') || '1', 10) || 1;
    state.serverPage = 1;
    state.page = 1;
  }
  function clientPages() { return Math.max(1, Math.ceil(state.total / state.perPage)); }

  function paint() {
    var s = $section(); if (!s) return;
    var its = $items();
    var start = (state.page - 1) * state.perPage, end = start + state.perPage;
    its.forEach(function (it, i) { it.style.display = (i >= start && i < end) ? '' : 'none'; });
    var a = state.total === 0 ? 0 : start + 1, b = Math.min(end, state.total);
    var pages = clientPages();
    s.querySelectorAll('[data-gp-count]').forEach(function (el) { el.textContent = a + '–' + b + ' of ' + state.total + ' Results'; });
    s.querySelectorAll('[data-gp-perpage]').forEach(function (btn) {
      btn.classList.toggle('is-selected', parseInt(btn.getAttribute('data-gp-perpage'), 10) === state.perPage);
    });
    s.querySelectorAll('[data-gp-prev]').forEach(function (b2) { var d = state.page <= 1; b2.classList.toggle('is-disabled', d); b2.disabled = d; });
    s.querySelectorAll('[data-gp-next]').forEach(function (b2) { var d = state.page >= pages; b2.classList.toggle('is-disabled', d); b2.disabled = d; });
    s.querySelectorAll('[data-gp-goto-select]').forEach(function (sel) {
      if (sel.getAttribute('data-built') !== String(pages)) {
        var html = ''; for (var i = 1; i <= pages; i++) html += '<option value="' + i + '">' + i + '</option>';
        sel.innerHTML = html; sel.setAttribute('data-built', String(pages));
      }
      sel.value = String(state.page);
    });
  }

  function ensureAndPaint(scroll) {
    var need = state.page * state.perPage;
    if (need <= state.loaded || state.serverPage >= state.serverPages || state.loading) {
      paint(); if (scroll) scrollToTop(); return;
    }
    var s = $section(); s.classList.add('gp-loading'); state.loading = true;
    var sid = s.getAttribute('data-section-id');
    var n = state.serverPage + 1;
    var q = location.pathname + location.search;
    var url = q + (q.indexOf('?') > -1 ? '&' : '?') + 'page=' + n + '&section_id=' + encodeURIComponent(sid);
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var g = $grid();
      doc.querySelectorAll('[data-product-container] .m-product-item').forEach(function (it) { g.appendChild(it); });
      state.serverPage = n; state.loaded = $items().length; state.loading = false;
      s.classList.remove('gp-loading');
      reinitImages(g); reinitProducts();
      if (state.page * state.perPage > state.loaded && state.serverPage < state.serverPages) ensureAndPaint(scroll);
      else { paint(); if (scroll) scrollToTop(); }
    }).catch(function () { state.loading = false; s.classList.remove('gp-loading'); paint(); });
  }

  function setPerPage(n) { state.perPage = n; try { localStorage.setItem('gpPerPage', n); } catch (e) {} state.page = 1; ensureAndPaint(false); }
  function goTo(p) { state.page = Math.min(Math.max(1, p), clientPages()); ensureAndPaint(true); }

  /* ---------- URL building (client-side — Liquid can't read query params) ----------
     Shopify Liquid has no access to the query string (request.search_params is empty),
     so SORT links and the custom PRICE buckets can't be built or marked active server-
     side. We do it here from the real location.search, preserving every active filter. */
  function buildUrl(ch) {
    var u = new URL(location.pathname + location.search, location.origin);
    var p = u.searchParams;
    (ch.del || []).forEach(function (k) { p.delete(k); });
    var set = ch.set || {};
    Object.keys(set).forEach(function (k) { p.set(k, set[k]); });
    p.delete('page'); p.delete('section_id'); // reset paging on filter/sort change
    var qs = p.toString();
    return u.pathname + (qs ? '?' + qs : '');
  }
  function syncPriceActive() {
    var s = $section(); if (!s) return;
    var cur = new URLSearchParams(location.search);
    var gte = cur.get('filter.v.price.gte') || '', lte = cur.get('filter.v.price.lte') || '';
    s.querySelectorAll('a[data-gp-price-gte]').forEach(function (a) {
      var bg = a.getAttribute('data-gp-price-gte') || '', bl = a.getAttribute('data-gp-price-lte') || '';
      a.classList.toggle('is-active', bg === gte && bl === lte && (gte !== '' || lte !== ''));
    });
  }

  /* ---------- filter / sort → AJAX section swap ---------- */
  function swapNavigate(targetUrl) {
    var s = $section(); if (!s) { location.href = targetUrl; return; }
    var sid = s.getAttribute('data-section-id'); if (!sid) { location.href = targetUrl; return; }
    s.classList.add('gp-loading');
    var join = targetUrl.indexOf('?') > -1 ? '&' : '?';
    fetch(targetUrl + join + 'section_id=' + encodeURIComponent(sid))
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector(SECTION_SEL) || doc.querySelector('.facest-filters-section');
        if (!fresh) { location.href = targetUrl; return; }
        s.innerHTML = fresh.innerHTML;
        try { history.pushState({ gp: 1 }, '', targetUrl); } catch (e) {}
        initUI(s); applyMobileDefault(); readState(true); paint(); syncPriceActive();
        reinitImages(s); reinitProducts();
        s.classList.remove('gp-loading'); scrollToTop();
      })
      .catch(function () { location.href = targetUrl; });
  }

  /* ---------- bind (delegated on the persistent section element) ---------- */
  function bind() {
    var s = $section(); if (!s || s.__gpBound) return; s.__gpBound = true;
    s.addEventListener('click', function (e) {
      // SORT — rebuild from the live URL so active filters are preserved
      var sortEl = e.target.closest('a[data-gp-sort]');
      if (sortEl) { e.preventDefault(); swapNavigate(buildUrl({ set: { sort_by: sortEl.getAttribute('data-gp-sort') } })); return; }
      // PRICE preset bucket — toggle on/off, preserving other filters
      var priceEl = e.target.closest('a[data-gp-price-gte]');
      if (priceEl) {
        e.preventDefault();
        var pgte = priceEl.getAttribute('data-gp-price-gte') || '', plte = priceEl.getAttribute('data-gp-price-lte') || '';
        var cur = new URLSearchParams(location.search);
        var on = (cur.get('filter.v.price.gte') || '') === pgte && (cur.get('filter.v.price.lte') || '') === plte;
        var ch = { del: ['filter.v.price.gte', 'filter.v.price.lte'], set: {} };
        if (!on) { if (pgte) ch.set['filter.v.price.gte'] = pgte; if (plte) ch.set['filter.v.price.lte'] = plte; }
        swapNavigate(buildUrl(ch)); return;
      }
      var link = e.target.closest('a.gp-facet__link, a.gp-sort__item, a.gp-swatch');
      if (link && !link.classList.contains('is-disabled')) {
        var h = link.getAttribute('href');
        if (h && h !== '#') { e.preventDefault(); swapNavigate(h); }
        return;
      }
      var pp = e.target.closest('[data-gp-perpage]');
      if (pp) { e.preventDefault(); setPerPage(parseInt(pp.getAttribute('data-gp-perpage'), 10)); return; }
      var prev = e.target.closest('[data-gp-prev]');
      if (prev) { e.preventDefault(); if (state.page > 1) goTo(state.page - 1); return; }
      var next = e.target.closest('[data-gp-next]');
      if (next) { e.preventDefault(); goTo(state.page + 1); return; }
    });
    s.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-gp-goto-select]');
      if (sel) goTo(parseInt(sel.value, 10));
    });
  }

  window.addEventListener('popstate', function () {
    if ($section()) swapNavigate(location.pathname + location.search);
  });

  function boot() { initUI(document); applyMobileDefault(); readState(false); paint(); syncPriceActive(); bind(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  var _mq = window.matchMedia('(max-width: 899px)');
  if (_mq.addEventListener) _mq.addEventListener('change', applyMobileDefault);
  document.addEventListener('shopify:section:load', function (e) { initUI(e.target); applyMobileDefault(); readState(false); paint(); syncPriceActive(); bind(); });
})();
